import { render, staticRenderFns } from "./Index_bak.vue?vue&type=template&id=c675f0c4&scoped=true&"
import script from "./Index_bak.vue?vue&type=script&lang=js&"
export * from "./Index_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c675f0c4",
  null
  
)

export default component.exports